module.exports = __webpack_public_path__ + "static/media/PlayVideo.2482d9aa.svg";